import React, { Component } from 'react';
import { Modal, Button, Form, Input, Select } from 'antd';
import Request from 'superagent';
import validator from "email-validator";
import NotificationManager from '../../commons/CustomNotificationManager.js';
const FormItem = Form.Item;

class TenantAddFrom extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            saving: false,
            emailFail: false,
            defaultLanguage: 'American English: en-US'
        }
    }

    close = () => {
        this.setState({
            showModal: false,
            defaultLanguage: 'American English: en-US'
        });
        this.props.onClose();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.showModal && nextProps.showModal !== this.state.showModal) {
            this.props.form.resetFields();
            this.setState({showModal: nextProps.showModal})
        }
    }

    save = () => {
        this.props.form.validateFields((err, newTenant) => {
            if (!err) {
                this.setState({saving: true});
                if (newTenant['tenantID'].trim() === '') {
                    delete newTenant['tenantID'];
                }
                Request.post('/api/tenant-manager').withCredentials()
                    .set('Accept', 'application/json')
                    .send(newTenant)
                    .end((error, response) => {
                        this.setState({saving: false});
                        if (error) {
                            console.error(error);
                            if (error.status === 409) {
                                NotificationManager.error('Duplicate email domain or ID.');
                            } else {
                                NotificationManager.error('Failed to create new tenant.');
                            }
                        } else {
                            this.props.onSuccess();
                            NotificationManager.success('Succeed to create new tenant.');
                            this.close();
                        }
                    });
            }
        });
    }

    checkEmailPattern = (rule, value, callback) => {
        if (value && !validator.validate(value)) {
            callback("Please input a valid email address.");
        }
        callback();
    }

    render() {
        const langOptions = this.props.langOptions;
        const { saving, showModal, defaultLanguage } = this.state;

        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16}
            }
        };

        const children = [];
        for (var i = 0; i < langOptions.length; i++) {
            children.push(<Select.Option key={langOptions[i].value}>{langOptions[i].label}</Select.Option>);
        }

        return (
            <div>
                <Modal visible={showModal} title="Create New Tenant"
                       closable={ false } maskClosable={false} style={{ top: 70 }}
                       footer={[
                        <Button key="submit" type="primary" size="large" onClick={this.save} loading={saving}>
                            {saving ? 'Saving...' : 'Save'}
                        </Button>,
                        <Button key="back" size="large" onClick={this.close} disabled={saving}>Cancel</Button>
                    ]}>
                    <div>
                        <Form>
                            <FormItem {...formItemLayout} label="Company Name">
                                {getFieldDecorator('companyName', {
                                    initialValue: '',
                                    rules: [{required: true, message: "Company Name is required."}]
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="First Name">
                                {getFieldDecorator('firstName', {
                                    initialValue: '',
                                    rules: [
                                        {required: true, message: "First Name is required."},
                                        {
                                            pattern: /^[a-zA-Z0-9!"#$%&'()*+,./:;<=>?@[\] ^_`{|}~-]*$/,
                                            message: "Only English chars are allowed."
                                        }
                                    ]
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Last Name">
                                {getFieldDecorator('lastName', {
                                    initialValue: '',
                                    rules: [
                                        {required: true, message: "Last Name is required."},
                                        {
                                            pattern: /^[a-zA-Z0-9!"#$%&'()*+,./:;<=>?@[\] ^_`{|}~-]*$/,
                                            message: "Only English chars are allowed."
                                        }
                                    ]
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Email">
                                {getFieldDecorator('adminEmail', {
                                    initialValue: '',
                                    rules: [
                                        {required: true, message: "Email is required."},
                                        {validator: this.checkEmailPattern}
                                    ]
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Language">
                                {getFieldDecorator('language', {
                                    initialValue: defaultLanguage,
                                    rules: [{required: true, message: ""}]
                                })(
                                    <Select>
                                        {children}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="ID">
                                {getFieldDecorator('tenantID', {
                                    initialValue: ''
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                        </Form>
                    </div>
                </Modal>
            </div>
        );
    }

}

const TenantAddModal = Form.create()(TenantAddFrom);
export default TenantAddModal;


// WEBPACK FOOTER //
// ./src/modules/tenants/TenantAddModal.js